import {createSlice} from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const dispatcherPreferencesAdapter = getAdapter({idFieldName: 'value'} );

const dispatcherPreferencesSlice = createSlice({
    name: 'dispatcherPreferences',
    initialState: dispatcherPreferencesAdapter.getInitialState(),
    reducers: {
        setDispatcherPreferences: (state, {payload: {dispatcherPreferences}}) => {
            dispatcherPreferencesAdapter.setAll(state, dispatcherPreferences);
        }
    }
});

const selectors = dispatcherPreferencesAdapter.getSelectors(({dispatcherPreferences}) => dispatcherPreferences);

export const getDispatcherPreferences = state =>  selectors.selectAll(state);

export const {setDispatcherPreferences} = dispatcherPreferencesSlice.actions;
export default dispatcherPreferencesSlice.reducer;